/*
*###############################################################################
*Module Name                   : DesignationMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'
import DPTextBox from 'framework/components/DPTextBox'
import DPSwitch from 'framework/components/DPSwitch'
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import { loadPopupSearchPay } from "../../../framework/validators/SearchColumn"
import ReactPaginate from 'react-paginate';
import DPTextBoxforgrid from 'framework/components/DPTextBoxforgrid'

const TextContent = ({
    DescValue,
    DescOnChange,
    disabled,
    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    ErrorMsg,
    menuName, 
    SearchDisable,
    menuCode,
    SetGroups,
    groups,
    change
}) => {


    //*** useState to save table data */
    const [DataTables, SetDatatable] = useState([])

    const [HeadColumns, setHeadColumns] = useState([])
    const [groupFilter, SetGroupFilter] = useState("a")
    const ApiURL = window.Links.ApiURL

    useEffect(async () => {
        setHeadColumns(await loadPopupSearchPay(menuCode, 'GROUPS'))
    }, [menuCode]);
    //*** End of useStates */

    async function tog_backdrop() {
        modelTrigger();
    }

    useEffect(() => {
        SetDatatable(groups)
        console.log(1)
    }, [groups])

    //default sorted method
    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];


    function handleSwitchChanges(e, values, index) {

        const change = values;
        if (e) {
            change.check = true
        } else {
            change.check = false
        }

        var newStoles = [];

        for (var i = 0; i < groups.length; i++) {
            if (groups[i].code == change.code) {
                newStoles.push(change);
            } else {
                newStoles.push(groups[i]);
            }
        }

        SetGroups(newStoles);

    }



    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={6} className="mb-4-sm">
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Select Group*"
                                    textType="text"
                                    maxLength="50"
                                    value={DescValue}
                                    onChange={DescOnChange}
                                    disabled={disabled}
                                />
                            </Col>
                            <Col sm={12} md={4} className="mb-4-sm">
                                <Button
                                    onClick={() => {
                                        tog_backdrop()
                                    }}
                                    color="success"
                                    className="btn-sm"
                                    disabled={SearchDisable}
                                >
                                    <i
                                        className="mdi mdi-search-web"
                                        style={{ fontSize: "12px" }}
                                    ></i>
                                </Button>
                            </Col>

                            <DPSearchBoxDynamic
                                searchData={[]}
                                columns={HeadColumns}
                                defaultSorted={defaultSorted}
                                mainTitle={menuName + " Search"}
                                SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={modelOpen}
                                toggle={modelTrigger}
                                getSelect={GetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"GROUPS"}
                                MenuCode={menuCode}
                                KeyVal={"GRP"}
                                searchBy={"GS_FILENO"}
                                FilterStr={groupFilter}
                            />
                        </Row>
                        <Row>
                            <TableWithPagination DataTables={DataTables} handleSwitchChanges={handleSwitchChanges} change={change} />
                        </Row>


                    </CardText>
                </Col>
            </div>
        </React.Fragment>
    )

}

export default TextContent


const TableWithPagination = ({ DataTables, handleSwitchChanges, change, Disable }) => {


    const [DataTable, setDataTable] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [postsPerPage] = useState(10)
    const [searchTerm, setSearchTerm] = useState("")

    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = DataTable.slice(indexOfFirstPost, indexOfLastPost)


    useEffect(() => {
        setCurrentPage(1)
    }, [change])

    useEffect(() => {
        setDataTable(DataTables)
        console.log(DataTables)
    }, [DataTables])


    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };


    return (
        <React.Fragment>
            <Row className='mt-3 mb-3'>
                <Col sm={12} md={1} className="mb-12-sm w"  >
                    <Label>Code</Label>
                </Col>
                <Col sm={12} md={3} className="mb-12-sm w"  >
                    <Label>Name</Label>
                </Col>
                <Col sm={12} md={1} className="mb-12-sm w" style={{ width: '60px' }} >

                </Col>
            </Row>
            <Row>
                <Col md="12">
                    {console.log(currentPosts)}
                    {currentPosts.map((values, index) => {
                        return (
                            <TableRow
                                DataTables={DataTables}
                                values={values}
                                index={index}
                                handleSwitchChanges={handleSwitchChanges}
                                Disable={Disable}
                            />
                        )
                    })
                    }
                </Col>
            </Row>
            <Row>
                <Col md="12">
                    <ReactPaginate
                        previousLabel={'previous'}
                        nextLabel={'next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(DataTables.length / postsPerPage)}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        forcePage={currentPage - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-left'}


                    />
                </Col>
            </Row>

        </React.Fragment>
    )
}


const TableRow = ({ values, index, Disable, GroupCode, handleSwitchChanges }) => {

    const [checked, setChecked] = useState(false)

    useEffect(() => {
        setChecked(values.check)
    }, [values.check])

    return (
        <React.Fragment>
            <Row key={index} style={{ marginBottom: '5px' }}>
                <Col sm={12} md={1} className="mb-12-sm w"  >
                    <DPTextBoxforgrid
                        value={values.code}
                    />
                </Col>
                <Col sm={12} md={3} className="mb-12-sm w"  >
                    <DPTextBoxforgrid
                        value={values.name}
                    />
                </Col>
                <Col sm={12} md={1} className="mb-12-sm w" style={{ width: '60px' }} >
                    <DPSwitch
                        checked={checked}
                        onChange={(e) => {
                            setChecked(e)
                            handleSwitchChanges(e, values, index)
                        }}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )

}